// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBKs6G2uegNSByLkfzHF-nLGS5U1EX1P1s",
  authDomain: "e-store-ed22a.firebaseapp.com",
  projectId: "e-store-ed22a",
  storageBucket: "e-store-ed22a.firebasestorage.app",
  messagingSenderId: "536666003617",
  appId: "1:536666003617:web:1391520ea6583caa0cb8e0",
  measurementId: "G-HRG1R68057",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default getFirestore();
